<template>
    <div
        class="left-sidebar"
        :class="{ 'open-sidebar': openSidebar }"
        ref="mobileNav"
        @blur="focusOutSidebar($event)"
        tabindex="0"
    >
        <div class="close-menu-icon">
            <a href="javascript:;" @click="closeSidebar()">
                <img src="/assets/img/cross-dark.svg" alt="" width="15" />
            </a>
        </div>
        <div class="left-logo">
            <router-link :to="{ path: '/apps' }">
                <img
                    src="/assets/img/logo-icon.svg"
                    alt=""
                    width="36"
                    class="small-logo"
                />
                <img
                    src="/assets/img/logo.svg"
                    alt=""
                    width="232"
                    class="big-logo"
                />
            </router-link>
        </div>
        <div
            class="sidebar-menu"
            v-bind:class="{ 'sidebar-menu-team': activeTeam }"
        >
            <ul
                :class="{
                    'max-hgt':
                        $route.path == '/chat' &&
                        chatRooms &&
                        chatRooms.length > 2
                }"
            >
                <router-link
                    v-for="route in routes"
                    v-bind:to="route.path"
                    v-bind:key="route.path"
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <li
                        :class="[
                            isActive && 'active',
                            isExactActive && 'active'
                        ]"
                        @focusout="focusOutHover($event)"
                        tabindex="0"
                    >
                        <a :href="href" @click="navigate">
                            <span v-html="route.meta.svg"></span>
                            <span class="hover-menu">
                                <span
                                    >{{ route.name }}
                                    <span
                                        class="red-badge"
                                        v-if="
                                            route.path == '/chat' &&
                                                totalUnreadMessages
                                        "
                                        >{{ totalUnreadMessages }}</span
                                    >
                                    <svg
                                        class="projects-plus"
                                        onclick="return false"
                                        v-if="route.path == '/projects'"
                                        @click="
                                            $router.push({
                                                name: 'Create Project'
                                            })
                                        "
                                        width="20"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            fill="currentColor"
                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                        ></path>
                                    </svg>
                                </span>
                            </span>
                        </a>
                        <ul
                            v-if="route.path == '/projects' && isActive"
                            class="project-list"
                        >
                            <li
                                v-for="project in projects"
                                :key="project.id"
                                :class="{
                                    active: project.id == $route.params.id
                                }"
                            >
                                <router-link
                                    :to="{
                                        name: 'Project View',
                                        params: { id: project.id }
                                    }"
                                    >{{ project.name.substring(0, 21)
                                    }}<span v-if="project.name.length > 21"
                                        >...</span
                                    ></router-link
                                >
                            </li>
                        </ul>
                        <ul
                            v-if="route.path == '/chat' && isActive"
                            class="project-list"
                        >
                            <li
                                v-for="chatRoom in chatRooms"
                                :key="chatRoom.id"
                                :class="{
                                    active: chatRoom.id == $route.query.id,
                                    gold: chatRoom.name != 'Global'
                                }"
                            >
                                <router-link
                                    :to="{
                                        name: 'The HUB',
                                        query: { id: chatRoom.id }
                                    }"
                                >
                                    <span v-if="chatRoom.name == 'Global'"
                                        >HUB Chat
                                        <span
                                            class="red-badge"
                                            v-if="chatRoom.unread_messages"
                                            >{{
                                                chatRoom.unread_messages
                                            }}</span
                                        ></span
                                    >
                                    <span v-else
                                        >{{ chatRoom.name.substring(0, 18) }}
                                        <span
                                            class="red-badge"
                                            v-if="chatRoom.unread_messages"
                                            >{{
                                                chatRoom.unread_messages
                                            }}</span
                                        ><span v-if="chatRoom.name.length > 18"
                                            >...</span
                                        ></span
                                    >
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </router-link>
            </ul>

            <ul class="share-feedback">
                <li v-if="isLoggedIn">
                    <div class="dropdown-profile-active-space">
                        <p class="text-part row">
                            <span class="fw-500">Active Space</span>
                            <span
                                v-if="activeTeam && team"
                                class="blue-txt-bold mt-1"
                                >{{ team.name }}</span
                            >
                            <span v-else class="blue-txt-bold mt-1"
                                >Personal</span
                            >
                        </p>
                        <div class="spaces row">
                            <div
                                class="space left"
                                :class="{ active: activeTeam }"
                                @click="$router.push({ name: 'Switch Team' })"
                            >
                                Team Space
                            </div>
                            <div
                                :class="{ active: !activeTeam }"
                                class="space right"
                                @click="
                                    $router.push({
                                        name: 'Personal Space Switch'
                                    })
                                "
                            >
                                Personal Space
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "../api/api.service";

export default {
    name: "SideBar.vue",
    data() {
        return {
            routes: this.whiteList(),
            openSidebar: false,
            user: {
                free_plan: true
            },
            teamClick: false,
            projectsClick: false,
            activeTeam: false,
            team: null,
            projects: [],
            chatRooms: [],
            totalUnreadMessages: 0
        };
    },
    watch: {
        openSidebar: function(val) {
            if (val) {
                this.$refs.mobileNavItems.focus();
            }
        },
        $route(to, from) {
            if (
                from.path == "/switch-personal-space" ||
                from.path == "/teams/switch"
            ) {
                this.routes = this.whiteList();

                this.user = JSON.parse(window.localStorage.getItem("user"));

                this.activeTeam = this.user.team_id ? true : false;
                if (this.user.team_id) {
                    this.team = this.user.team;
                }
            }

            // watch chat room
            if (to.path == "/chat" && to.query.id) {
                this.chatRooms.forEach((chatR, index) => {
                    if (chatR.id === to.query.id) {
                        this.totalUnreadMessages -= chatR.unread_messages ?? 0;
                        this.chatRooms[index].unread_messages = 0;
                    }
                });
            }

            if (to) {
                this.getLatestProjects();
            }
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "isLoggedIn"
        })
    },
    mounted() {
        if (this.isLoggedIn) {
            ApiService.setHeader();
            ApiService.get("/api/user")
                .then(({ data }) => {
                    this.user = data;
                    window.localStorage.setItem("user", JSON.stringify(data));
                    this.activeTeam = this.user.team_id ? true : false;
                    if (this.user.team_id) {
                        this.team = this.user.team;
                    }
                    if (
                        this.user &&
                        this.user.team_id &&
                        this.user.team_role == "member"
                    ) {
                        this.routes = this.routes.filter(route => {
                            return route.path != "/teams";
                        });
                    }

                    if (!this.user.free_plan) {
                        this.getLatestProjects();
                    }
                })
                .catch(error => {
                    throw new Error("failed to load user");
                });

            this.getChatRooms();

            if (this.$route.path == "/chat") {
                setTimeout(() => {
                    if (this.chatRooms && this.chatRooms.length > 0) {
                        this.chatRooms.forEach((chatRoom, index) => {
                            if (chatRoom.id == this.$route.query.id) {
                                this.totalUnreadMessages -=
                                    this.chatRooms[index].unread_messages ?? 0;
                                this.chatRooms[index].unread_messages = 0;
                            }
                        });
                    }
                }, 1000);
            }

            setInterval(() => {
                this.getChatRooms();
            }, 30000);
        }
    },

    methods: {
        whiteList: function() {
            let sidebarRoutes = [];

            this.$router.options.routes.forEach(function(route) {
                let sideBarUrls = [
                    "/apps",
                    "/community",
                    "/chat",
                    "/documents",
                    "/teams",
                    "/projects"
                ];
                if (sideBarUrls.indexOf(route.path) !== -1) {
                    sidebarRoutes.push(route);
                }
            }, sidebarRoutes);

            return sidebarRoutes;
        },

        closeSidebar() {
            this.openSidebar = false;
        },

        focusOutSidebar(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.$refs.mobileNav.classList.remove("open-sidebar");
                // this.openSidebar = false;
            }
        },

        showHover(name) {
            if (name == "Projects") {
                this.projectsClick = !this.projectsClick;
            } else {
                this.teamClick = !this.teamClick;
            }
        },

        focusOutHover(e) {
            this.projectsClick = false;
            this.teamClick = false;
        },

        getLatestProjects() {
            ApiService.setHeader();
            ApiService.get("/api/projects?latest=4")
                .then(({ data }) => {
                    this.projects = data.projects;
                })
                .catch(response => {
                    console.log(response);
                });
        },

        setChatViewed() {
            if (this.chatRooms && this.chatRooms.length) {
                this.chatRooms.forEach((chatRoom, index) => {
                    if (chatRoom.id == this.$route.query.id) {
                        this.totalUnreadMessages -=
                            this.chatRooms[index].unread_messages ?? 0;
                        this.chatRooms[index].unread_messages = 0;
                    }
                });
            }
        },

        getChatRooms(setGlobalViewed = false) {
            ApiService.setHeader();
            ApiService.get("/api/chat/rooms")
                .then(({ data }) => {
                    this.chatRooms = data.rooms;
                    this.totalUnreadMessages = 0;
                    this.chatRooms.forEach((chatRoom, index) => {
                        this.chatRooms[index].unread_messages =
                            data.unread_messages[chatRoom.id];
                        this.totalUnreadMessages +=
                            data.unread_messages[chatRoom.id];
                    });

                    if (setGlobalViewed) {
                        setTimeout(() => {
                            this.chatRooms.forEach((chatRoom, index) => {
                                if (chatRoom.name == "Global") {
                                    this.totalUnreadMessages =
                                        this.totalUnreadMessages -
                                        chatRoom.unread_messages;
                                    this.chatRooms[index].unread_messages = 0;
                                }
                            });
                        }, 800);
                    }
                })
                .catch(response => {
                    console.log(response);
                });
        }
    }
};
</script>

<style scoped>
.dropdown-profile-active-space p.text-part {
    width: 215px;
    margin-bottom: 10px;
    color: #c7ccd2;
}

.dropdown-profile-active-space p.text-part span {
    width: 100%;
    margin: auto;
    font-weight: 400;
}

.dropdown-profile-active-space p.text-part span.blue-txt-bold {
    font-weight: 700;
    color: #23a6cd;
}

.dropdown-profile-active-space .spaces {
    margin-bottom: 20px;
}

.dropdown-profile-active-space .spaces .space {
    background-color: #dfdfdf;
    color: #686a72;
    /* color: #16181f; */
    display: inline-block;
    padding: 4px 9px;
}
.dropdown-profile-active-space .spaces .space.active {
    background-color: #23a6cd;
    color: #ffffff;
}
.dropdown-profile-active-space .spaces .space:hover {
    /* background-color: #dfdfdf; */
    color: #16181f;
    cursor: pointer;
}

.dropdown-profile-active-space .spaces .space.left {
    border-radius: 4px 0 0 4px;
    cursor: pointer;
}
.dropdown-profile-active-space .spaces .space.right {
    border-radius: 0 4px 4px 0;
    border-left: none;
    cursor: pointer;
}


@media screen and (max-width: 991px) {
    .dropdown-profile-active-space {
        display: none;
    }
}

.width-80 .dropdown-profile-active-space {
    display: none;
}

.sidebar-menu svg.projects-plus {
    left: 177px;
    /*background: #1e73bd;*/
    border-radius: 20px;
    /*stroke: #fff;*/
    visibility: hidden;
}

.sidebar-menu-team {
    /* background: #dcdcdc; */
    background: #353f4d;
}

.sidebar-menu li:hover svg.projects-plus,
.sidebar-menu li.active svg.projects-plus {
    background: #fff;
    stroke: #1e73bd;
    display: block;
    visibility: visible;
}



ul.project-list li {
    margin-top: 5px;
    font-weight: 500;
}
ul.project-list li a {
    background: none !important;
    color: #c7ccd2 !important;
    display: block;
    padding: 2px 5px 2px 60px !important;
    font-size: 14px;
    font-weight: 500;
    border-radius: 0 6px 6px 0;
    position: relative;
    white-space: nowrap;
    box-shadow: none;
}

ul.project-list li.active a,
ul.project-list li:hover a {
    background: #23a6cd !important;
    color: #fff !important;
    box-shadow: none;
}

ul.project-list li.active.gold a,
ul.project-list li.gold:hover a {
    background: #ba8c00 !important;
}

@media screen and (max-width: 991px) {
    ul.project-list li {
        display: none;
    }
}

.width-80 ul.project-list li {
    display: none;
}

.fw-500 {
    font-weight: 500 !important;
}

.red-badge {
    color: #ffffff;
    background-color: #f02948;
    border-radius: 10px;
    padding: 2px 7px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
}
</style>
